module.exports = __webpack_public_path__ + "img/66701599298__A3489AEF-5410-4508-B399-6385EA0F5E1C-cropped-6pxgauss-compress-85-mobile.d1e62f35.webp";